import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";
import defaultPageAttributes from "objs/_defaultPageAttributes";

const ProjectConfigurator = Scrivito.provideObjClass("ProjectConfigurator", {
  attributes: {
    body: ["widgetlist", { only: "InfoPopupWidget" }],
    ...metadataAttributes,
    ...defaultPageAttributes,
    redirectAfterDelete: ["reference", { only: "ProjectList" }],
  },
  extractTextAttributes: ["body", "title", "subtitle"],
});

export default ProjectConfigurator;
